import React from 'react';
import cn from 'classnames';
import { Price } from 'swag-client-common/utils/price';
import SetupFeeTooltip from 'swag-client-common/components/partials/setupfee-tooltip';
import classes from './related-items-summary.scss';
const RelatedItemsSummary = ({
  total,
  setupFee,
  oldSetupFee,
  wrapperClassName = ''
}) => {
  const shouldShowSetupFeeTooltip = setupFee > 0 && !oldSetupFee;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.summary, wrapperClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Setup Fee:"), !!oldSetupFee && /*#__PURE__*/React.createElement("div", {
    className: classes.crossedBold,
    "data-text": "RelatedOldSetupFee"
  }, Price.formatPrice(oldSetupFee)), /*#__PURE__*/React.createElement("div", {
    className: cn(classes.blackBold, {
      [classes.stickyRight]: shouldShowSetupFeeTooltip
    }),
    "data-text": "RelatedSetupFee"
  }, Price.formatPrice(setupFee)), shouldShowSetupFeeTooltip && /*#__PURE__*/React.createElement(SetupFeeTooltip, {
    infoWrapperClassName: classes.setupFeeInfoWrapper,
    infoButtonClassName: classes.infoButton
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Total:"), /*#__PURE__*/React.createElement("div", {
    className: classes.pinkBold,
    "data-text": "RelatedProductsTotal"
  }, Price.formatPrice(total))));
};
export default RelatedItemsSummary;